export const BASE_URL_B2C = '/learn';
